module.exports = __webpack_public_path__ + "img/mastercard.eeca79ed.svg";